import React, { useState, useCallback } from 'react';
import ModalContentBase from '../modal/hooks/modal_content_base';
import {
  TEXT,
  HEADING_LARGE,
  HEADING_MEDIUM,
  HEADING_SMALL,
  IMAGE,
  INSTAGRAM,
  YOUTUBE,
  FREE,
  NOTE,
  DELETE,
  COURSE,
} from './const';

// ブログ作成（画面107）だけで使うメニューの見た目。改修ずみ画面の「⋮」メニュー
// （アルバム一覧・メンバー一覧）と同じ「左にアイコン＋言葉、削除だけ赤」の形。
// 運営の編集画面（記事・パーティーなど）は従来のまま
const svgProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
};
const headingIcon = (level) => (
  <svg {...svgProps}>
    <path d="M4 5v14M13 5v14M4 12h9" />
    <text x="16" y="19" fontSize="9" fontWeight="700" fill="currentColor" stroke="none">
      {level}
    </text>
  </svg>
);
const BLOG_MENU_ITEMS = [
  [TEXT, '本文', <svg {...svgProps}><path d="M4 6h16M4 12h16M4 18h10" /></svg>],
  [HEADING_LARGE, '大見出し', headingIcon(1)],
  [HEADING_MEDIUM, '中見出し', headingIcon(2)],
  [HEADING_SMALL, '小見出し', headingIcon(3)],
  [IMAGE, '画像', <svg {...svgProps}><rect x="3" y="4" width="18" height="16" rx="3" /><circle cx="9" cy="10" r="1.8" /><path d="m21 16-5-5-9 9" /></svg>],
  [YOUTUBE, 'YouTube', <svg {...svgProps}><rect x="2.5" y="5" width="19" height="14" rx="4" /><path d="m10 9.5 5 2.5-5 2.5z" /></svg>],
  [INSTAGRAM, 'Instagram', <svg {...svgProps}><rect x="3" y="3" width="18" height="18" rx="5" /><circle cx="12" cy="12" r="4" /><circle cx="17.3" cy="6.7" r=".6" fill="currentColor" /></svg>],
];
const BLOG_MENU_DELETE = [
  DELETE,
  '削除',
  <svg {...svgProps}><path d="M3 6h18" /><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" /><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" /></svg>,
];

const BLOG_MENU_REORDER = [
  'reorder',
  '並べかえ',
  <svg {...svgProps}><path d="M7 4v16M3 8l4-4 4 4M17 20V4M13 16l4 4 4-4" /></svg>,
];

// 種類の一覧と、行そのものへの操作（並べかえ・削除）は分けて見せる。
// 書いた行のメニューでは「種類を変更」の見出しの下に種類、線で区切って操作を並べる
const BlogTypeMenu = ({ isEnterSection, onSelect, canReorder, showLabel }) => {
  const actions = isEnterSection
    ? []
    : [...(canReorder ? [BLOG_MENU_REORDER] : []), BLOG_MENU_DELETE];
  const renderItems = (items) =>
    items.map(([type, label, icon]) => (
      <li key={type}>
        <button
          type="button"
          className={`be-typemenu__item${
            type === DELETE ? ' be-typemenu__item--danger' : ''
          }${type === 'reorder' ? ' be-typemenu__item--reorder' : ''}`}
          onClick={() => onSelect(type)}
        >
          {icon}
          {label}
        </button>
      </li>
    ));
  return (
    <>
      {showLabel && <p className="be-typemenu__label">種類を変更</p>}
      <ul className="be-typemenu__list">{renderItems(BLOG_MENU_ITEMS)}</ul>
      {actions.length > 0 && (
        <ul className="be-typemenu__list be-typemenu__list--actions">
          {renderItems(actions)}
        </ul>
      )}
    </>
  );
};

const TypeSelect = ({
  isCoursesDisplayed,
  onChangeType,
  content,
  isEnterSection,
  deleteContent,
  userAgent,
  model,
}) => {
  // note埋め込みは記事本文エディタ限定で出す
  const isNoteDisplayed = model === 'Article';
  // TODO SP版の修正
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDroppedDown, setIsDroppedDown] = useState(false);

  const closeModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const handleModalClick = (type) => {
    if (type === DELETE) {
      deleteContent();
    } else {
      onChangeType(type);
    }
    setIsModalOpen(false);
  };

  const isBlogMenu = model === 'Blog';

  // スマホだけ、書いた行のメニューに「並べかえ」を出す（並べかえモードは blog2023/edit.js）
  const canReorder = isBlogMenu && userAgent !== 'pc';
  const handleBlogModalClick = (type) => {
    if (type === 'reorder') {
      setIsModalOpen(false);
      window.dispatchEvent(new Event('blog-editor:reorder'));
      return;
    }
    handleModalClick(type);
  };

  const handleBlogMenuClick = (type) => {
    handleModalClick(type);
    setIsDroppedDown(false);
  };

  const handleSelectChange = (e) => {
    if (e.target.value === DELETE.toString()) {
      deleteContent();
    } else {
      onChangeType(Number(e.target.value));
    }
    setIsDroppedDown(false);
  };

  return (
    <div
      className="mt-3 pt-1 position-relative"
      onMouseLeave={() => userAgent === 'pc' && setIsDroppedDown(false)}
    >
      <img
        id=""
        className="cursor-pointer"
        src="/assets2019/img/icon_plus.svg"
        width="32"
        height="32"
        alt=""
        onClick={() => {
          if (userAgent === 'pc') {
            setIsDroppedDown((prev) => !prev);
          } else {
            setIsModalOpen(true);
          }
        }}
      />
      {isDroppedDown && isBlogMenu ? (
        <div className="be-typemenu be-typemenu--dropdown">
          <BlogTypeMenu
            showLabel={!isEnterSection}
            isEnterSection={isEnterSection}
            onSelect={handleBlogMenuClick}
          />
        </div>
      ) : isDroppedDown ? (
        <div
          className="p-0 select-dropdown-menu"
          style={{
            width: '100px',
            top: '16px !important',
            left: '20px !important',
          }}
        >
          <select
            id="content_type"
            onClick={(e) => {
              handleSelectChange(e);
            }}
            className="p-2 w-100 textarea--eventreport custom-select custom-select--makecircle text-dark"
            size={isEnterSection ? '7' : '8'}
          >
            <option className="form-option" value={TEXT}>
              本文
            </option>
            <option className="form-option" value={HEADING_LARGE}>
              大見出し
            </option>
            <option className="form-option" value={HEADING_MEDIUM}>
              中見出し
            </option>
            <option className="form-option" value={HEADING_SMALL}>
              小見出し
            </option>
            <option className="form-option" value={IMAGE}>
              画像
            </option>
            <option className="form-option" value={INSTAGRAM}>
              Instagram
            </option>
            <option
              className="form-option"
              value={YOUTUBE}
              style={{ border: isEnterSection ? 'none' : '' }}
            >
              Youtube
            </option>
            {isNoteDisplayed ? (
              <option className="form-option" value={NOTE}>
                note埋め込み
              </option>
            ) : (
              <React.Fragment />
            )}
            {isCoursesDisplayed ? (
              <option value={COURSE}>コース挿入</option>
            ) : (
              <React.Fragment />
            )}
            {!isEnterSection && (
              <option
                className="form-option"
                style={{ border: 'none' }}
                value={DELETE}
              >
                削除
              </option>
            )}
          </select>
        </div>
      ) : null}
      {userAgent !== 'pc' && isModalOpen ? (
        <ModalContentBase
          closeModal={() => closeModal()}
          modalContent={
            isBlogMenu ? (
              <div className="be-typemenu be-typemenu--sheet">
                <div className="be-typemenu__head">
                  <p className="be-typemenu__title">
                    {isEnterSection ? '追加する内容' : 'この行を編集'}
                  </p>
                  <button
                    type="button"
                    className="be-typemenu__close"
                    aria-label="閉じる"
                    onClick={() => closeModal()}
                  >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" /></svg>
                  </button>
                </div>
                <BlogTypeMenu
                  showLabel={!isEnterSection}
                  isEnterSection={isEnterSection}
                  onSelect={handleBlogModalClick}
                  canReorder={canReorder}
                />
              </div>
            ) : (
            <div className="card bg-gray pt-3">
              <button
                type="button"
                className="close close__modal position-absolute position--modalclose"
                aria-label="Close"
                onClick={() => closeModal()}
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h6 className="text-fw-bold text-center mb-3_5">
                コンテンツタイプを選択してください
              </h6>
              <div className="card bg-white">
                <div
                  className="p-3"
                  onClick={() => {
                    handleModalClick(TEXT);
                  }}
                >
                  本文
                </div>
                <div
                  className="p-3"
                  onClick={() => {
                    handleModalClick(HEADING_LARGE);
                  }}
                >
                  大見出し
                </div>
                <div
                  className="p-3"
                  onClick={() => {
                    handleModalClick(HEADING_MEDIUM);
                  }}
                >
                  中見出し
                </div>
                <div
                  className="p-3"
                  onClick={() => {
                    handleModalClick(HEADING_SMALL);
                  }}
                >
                  小見出し
                </div>
                <div
                  className="p-3"
                  onClick={() => {
                    handleModalClick(IMAGE);
                  }}
                >
                  画像
                </div>
                <div
                  className="p-3"
                  onClick={() => {
                    handleModalClick(YOUTUBE);
                  }}
                >
                  Youtube
                </div>
                <div
                  className="p-3"
                  onClick={() => {
                    handleModalClick(INSTAGRAM);
                  }}
                >
                  Instagram
                </div>
                {isNoteDisplayed ? (
                  <div
                    className="p-3"
                    onClick={() => {
                      handleModalClick(NOTE);
                    }}
                  >
                    note埋め込み
                  </div>
                ) : null}
                {isCoursesDisplayed ? (
                  <div
                    className="p-3"
                    onClick={() => {
                      handleModalClick(COURSE);
                    }}
                  >
                    コース挿入
                  </div>
                ) : null}
                {!isEnterSection && (
                  <div
                    className="p-3"
                    onClick={() => {
                      handleModalClick(DELETE);
                    }}
                  >
                    削除
                  </div>
                )}
              </div>
            </div>
            )
          }
        />
      ) : null}
    </div>
  );
};

export default TypeSelect;
